import Vue from 'vue'

export default {
    resetStateMutation(state) {
        Vue.set(state, "formIsOpen", false);
        Vue.set(state, "gridIsOpen", true);
    },
    setFormOpenEprofileVedooltasok(state) {
        state.formIsOpen = true;
        state.gridIsOpen = false;
    },
    setFormCloseEprofileVedooltasok(state) {
        state.formIsOpen = false;
        state.gridIsOpen = true;
    }
}
